// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1Hdi0","label":"Completed_label__Wx4r5"};